import { useState, useEffect } from "react";
import { supabase } from '../supabase';

const C = {
  bg:"#0e0e0e", sidebar:"#0a0a0a", surface:"#181818", surface2:"#202020",
  border:"#2a2a2a", muted:"#666", orange:"#FF5F1F", magenta:"#E8197D",
  gold:"#F5A623", green:"#4ade80", white:"#fff", red:"#f87171", blue:"#60a5fa",
};
const card     = (x={}) => ({ background:C.surface, borderRadius:10, padding:16, border:`0.5px solid ${C.border}`, ...x });
// eslint-disable-next-line no-unused-vars
const btn      = (v="primary",x={}) => ({ padding:"8px 16px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer", border:"none", boxSizing:"border-box", ...(v==="primary"?{background:`linear-gradient(135deg,${C.orange},${C.magenta})`,color:C.white}:{}), ...(v==="ghost"?{background:"none",border:`0.5px solid ${C.border}`,color:C.muted}:{}), ...x });
const gradBar  = <div style={{height:2,background:`linear-gradient(90deg,${C.orange},${C.magenta},${C.gold})`,borderRadius:1,marginBottom:24}}/>;
const secTitle = t => <div style={{fontSize:11,color:C.muted,marginBottom:12,letterSpacing:0.5,textTransform:"uppercase"}}>{t}</div>;

function Toggle({ on, onClick }) {
  return (
    <div onClick={onClick} style={{width:40,height:22,borderRadius:11,background:on?C.orange:"#333",border:`0.5px solid ${on?C.orange:C.border}`,position:"relative",cursor:"pointer",flexShrink:0,transition:"background 0.2s"}}>
      <div style={{position:"absolute",top:3,left:on?20:3,width:16,height:16,borderRadius:"50%",background:"#fff",transition:"left 0.2s"}}/>
    </div>
  );
}

function Toast({ msg, ok=true }) {
  if(!msg) return null;
  return <div style={{position:"fixed",bottom:72,left:"50%",transform:"translateX(-50%)",background:C.surface,border:`0.5px solid ${ok?C.green:C.red}44`,color:ok?C.green:C.red,padding:"10px 20px",borderRadius:20,fontSize:13,zIndex:400,whiteSpace:"nowrap"}}>{msg}</div>;
}

export default function SettingsPage({ user, isMobile }) {
  const [allowArtistAvailability, setAllowArtistAvailability] = useState(true);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ msg:"", ok:true });

  const showToast = (msg, ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast({msg:"",ok:true}), 2500); };

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase
        .from('settings')
        .select('*');
      if(data) {
        const s = Object.fromEntries(data.map(r => [r.key, r.value]));
        if(s.allow_artist_availability !== undefined) setAllowArtistAvailability(s.allow_artist_availability);
      }
      setLoading(false);
    };
    load();
  }, []);

  const saveSetting = async (key, value) => {
    const { error } = await supabase
      .from('settings')
      .update({ value, updated_at: new Date().toISOString() })
      .eq('key', key);
    if(!error) showToast("Innstilling lagret!");
    else showToast("Kunne ikke lagre.", false);
  };

  const toggleArtistAvailability = async () => {
    const newVal = !allowArtistAvailability;
    setAllowArtistAvailability(newVal);
    await saveSetting('allow_artist_availability', newVal);
  };

  if(loading) return <div style={{color:C.muted, textAlign:"center", marginTop:40}}>Laster...</div>;

  return (
    <div style={{paddingBottom: isMobile?80:0, maxWidth:600}}>
      <Toast msg={toast.msg} ok={toast.ok}/>
      {gradBar}
      <div style={{fontSize:20, fontWeight:500, marginBottom:24}}>Innstillinger</div>

      {/* Kalender */}
      <div style={{...card(), marginBottom:16}}>
        {secTitle("Kalender")}
        <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", padding:"12px 0"}}>
          <div>
            <div style={{fontSize:13, fontWeight:500}}>Artister kan legge inn blokkerte perioder</div>
            <div style={{fontSize:11, color:C.muted, marginTop:3}}>
              Når dette er på kan alle brukere selv registrere når de er opptatt. Slår du det av er det kun admin som kan gjøre det.
            </div>
          </div>
          <div style={{marginLeft:16}}>
            <Toggle on={allowArtistAvailability} onClick={toggleArtistAvailability}/>
          </div>
        </div>
      </div>
    </div>
  );
}